// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronsUpDown from "@store/Library/Components/Toolkit/Icons/ChevronsUpDown";
import ChevronUp from "@store/Library/Components/Toolkit/Icons/ChevronUp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const baseCellStyles = () => css`
    height: auto;
    border: 0;
    text-align: left;
    line-height: ${x => x.theme.design.typography.lineHeight.small};
`;

/* Store Custom Code - Start */
const commonTypographyStyles = () => {
    return css`
        font-size: ${x => x.theme.design.typography.size.base};
        font-weight: ${x => x.theme.design.typography.weight.base};
    `;
};
/* Store Custom Code - End */

const dataTable: Styleguide["dataTable"] = {
    defaultProps: {
        /* Store Custom Code - Start */
        cssOverrides: {
            header: css`
                background-color: ${getColor("common.background")};
                border-bottom: 1px solid ${getColor("secondary")};

                a,
                button {
                    color: inherit;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            `,
            cell: css`
                ${commonTypographyStyles()}
                border-bottom: none;
            `,
            row: css`
                background-color: ${getColor("common.background")};
            `,
            evenRow: css`
                background-color: ${getColor("common.accent")};
            `,
        },
        headerTypographyProps: {
            css: css`
                ${commonTypographyStyles()}
                color: ${getColor("primary")};
            `,
        },
        cellTypographyProps: {
            css: css`
                ${commonTypographyStyles()}
            `,
        },
        /* Store Custom Code - End */
    },
};

export default dataTable;
